import { apiClient } from './api';
import type { TenantWorkDashboardResponse, TenantWorkRequestSummary, TenantWorkRequestUpdatePayload } from '../types';

export async function getWorkDashboard(): Promise<TenantWorkDashboardResponse> {
  const response = await apiClient.get<TenantWorkDashboardResponse>('/api/v1/web/work/dashboard');
  return response.data;
}

export async function updateWorkRequest(
  requestId: number,
  payload: TenantWorkRequestUpdatePayload
): Promise<TenantWorkRequestSummary> {
  const response = await apiClient.patch<TenantWorkRequestSummary>(`/api/v1/web/work/requests/${requestId}`, payload);
  return response.data;
}
